import React, {
  useContext,
  useEffect,
  useState,
  useCallback,
  useMemo,
  memo,
  useRef,
} from 'react';
import {
  Col,
  Container,
  Row,
} from 'reactstrap';
import axios from 'axios';
import NavBar from '../components/NavBar';
import SuggestedProfiles from '../components/feeds/sidebar/SuggestedProfiles';
import PostForm from '../components/feeds/createPost/PostForm';
import {
  _imagesURL,
  FeedPostApi,
  GetCommentsApi,
  RepostApi,
  ReserveApi,
  adminBaseURL,
  FollowApi,
} from '../constants/API';
import InfiniteScroll from 'react-infinite-scroller';
import { toast } from 'react-toastify';
import { FeedType, Language, PostDetailContext, LoginUserData } from '../App';
import PostCardShimmer from '../components/feeds/cards/PostCardShimmer.jsx';
import LiveFeeds from '../components/feeds/sidebar/LiveFeeds.jsx';
import FeedAdvertisement from '../components/feeds/sidebar/FeedAdvertisement.jsx';
import SuggestedCoursesEvents from '../components/feeds/sidebar/SuggestedCoursesEvents.jsx';
import FeedSponsorPost from '../components/feeds/sidebar/FeedSponsorPost.jsx';
import ProfileSuggestionSlider from '../components/feeds/sidebar/ProfileSuggestionSlider.jsx';
import {
  fetchFeedData,
  likePostApi,
  reactToPostApi,
  savePostApi,
  usersLikedPostApi,
} from '../services/feedApis.js';
import { useQuery } from 'react-query';
import { getToken } from '../shared/token.js';
import PollLikesModal from '../components/modals/PollLikesModal.jsx';
import LikeUsersModal from './LikeUsersModal.jsx';
import PostCard from './PostCard.jsx';
import ReportModal from './ReportModal.jsx';
import PostSideFilters from '../components/feeds/sidebar/PostSideFilters.jsx';
import FooterLinks from '../components/feeds/sidebar/FooterLinks.jsx';
import { useNavigate, useLocation } from 'react-router-dom';
import FeedMobileFilter from '../components/feeds/sidebar/FeedMobileFilter.jsx';
import MixpanelManager from '../constants/MixpanelManager';
import { MixpanelEvents } from '../constants/MixpanelEvents';
import { useCustomToast } from '../components/common/CustomToast';

import { calculateTotalReactions } from '../components/feeds/cards/PostFooter.jsx';

const Feed = memo(() => {
  const { showToast } = useCustomToast();
  const feedTypeContext = useContext(FeedType);
  const { feedType } = feedTypeContext || { feedType: 'all' };
  const postDetailContext = useContext(PostDetailContext);
  const { updatePostDetail } = postDetailContext || {};
  const languageContext = useContext(Language);
  const { lang } = languageContext || {};
  const { splashData } = useContext(LoginUserData) || {};
  const navigate = useNavigate();
  const location = useLocation();
  const [playingVideo, setPlayingVideo] = useState(-1);
  const [leftSideAds, setLeftSideAds] = useState([]);
  const [popularCourses, setPopularCourses] = useState([]);
  const [rightSideAds, setRightSideAds] = useState([]);
  const [suggestedEvents, setSuggestedEvents] = useState([]);
  const [contest_obj, setContestObj] = useState([]);
  const [leftSideFeeds, setLeftSideFeeds] = useState({});
  const [page, setPage] = useState(1);
  const [data, setData] = useState({});
  const [postData, setPostData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [postModal, setPostModal] = useState(false);
  const [postComments, setPostComments] = useState({});
  const [postId, setPostId] = useState('');
  const [postDropDown, setPostDropDown] = useState(false);
  const [dropDownId, setDropDownId] = useState(null);
  const [likeUsersModal, setLikeUsersModal] = useState(false);
  const [likeUsers, setLikeUsers] = useState({});
  const [likeSpinner, setLikeSpinner] = useState(false);
  const [likePage, setLikePage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [suggestionsData, setSuggestionsData] = useState([]);
  const [showPost, setShowPost] = useState(false);
  const [editWebinar, setEditWebinar] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [pollId, setPollId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [isFeedTypeChanging, setIsFeedTypeChanging] = useState(true); // Initialize to true for initial mount
  const [adsLoading, setAdsLoading] = useState(true);
  const [exitingPostIds, setExitingPostIds] = useState([]);
  // Track if this is the initial load and feed type changes
  const isInitialLoad = useRef(true);
  const previousFeedType = useRef(feedType);
  const isDataFromHomeApi = useRef(false); // Track if data came from home API
  const userData = localStorage.getItem('SignupData');
  const user = userData ? JSON.parse(userData) : null;
  const user_id = user?.data?.id;

  const authorize = {
    headers: {
      Authorization: `Bearer ${getToken()}`, // Set the Authorization header
    },
  };

  sessionStorage.setItem('feed_url', window.location.href);

  // Show shimmer on component mount
  useEffect(() => {
    setIsFeedTypeChanging(true); // Trigger shimmer on mount
  }, []);

  const formatFeedPosts = useCallback((postsList) => {
    if (!Array.isArray(postsList)) return [];

    const basePostsMap = new Map();
    postsList.forEach((p) => {
      if (p && p.id && !p.repost_user) {
        basePostsMap.set(p.id, p);
      }
    });

    return postsList.map((item) => {
      if (!item) return item;

      const isPoll = item.type === "poll" || Boolean(item.option_1);
      const originalPost = item.original_id ? basePostsMap.get(item.original_id) : null;
      const originalTime = item.original_time || originalPost?.time || item.time;

      let repostCaption = "";
      let postCaption = item.caption || "";

      if (item.repost_user) {
        if (item.repost_caption && typeof item.repost_caption === "string" && item.repost_caption.trim()) {
          repostCaption = item.repost_caption.trim();
          postCaption = isPoll ? "" : (originalPost?.caption || (item.caption !== item.repost_caption ? item.caption : ""));
        } else if (isPoll && item.caption && item.caption !== "..." && item.caption.trim()) {
          repostCaption = item.caption.trim();
          postCaption = "";
        } else {
          repostCaption = "";
          postCaption = isPoll ? "" : (originalPost?.caption || item.caption || "");
        }
      }

      const totalLikes = calculateTotalReactions(
        item.reaction_counts,
        item.likes_count ?? 0
      );

      return {
        ...item,
        time: originalTime,
        original_time: originalTime,
        caption: postCaption,
        repost_caption: repostCaption,
        original_caption: isPoll ? "" : (originalPost?.caption || postCaption),
        likes_count: totalLikes,
      };
    });
  }, []);

  const { isLoading: isLoadingFeeds, isRefetching, refetch } = useQuery({
    queryKey: ['feedData', feedType],
    queryFn: () => fetchFeedData({ feedType }),
    onMutate: () => {
      setLoading(true);
      setIsFeedTypeChanging(true); // Show shimmer during fetch
      setAdsLoading(true)
    },
    onSuccess: (data) => {

      if (data?.status === false && data?.action === "Unauthenticated request") {
        localStorage.clear();
        sessionStorage.clear();
        window.location.replace("/");
        return;
      }

      if (data?.status) {
        setLeftSideAds(data?.ads?.home_left);
        setPopularCourses(data.left.popular);
        setRightSideAds(data?.ads?.home_right);
        setSuggestedEvents(data.right.suggested);
        setContestObj(data?.ads?.home_center || []);
        setLeftSideFeeds(data?.left);

        // Set posts data from fetchFeedData response (Home API)
        if (data?.home?.posts?.data) {
          const incomingPosts = formatFeedPosts(data.home.posts.data);
          setPostData(incomingPosts);
          setData(data.home.posts);
          setPage(1);
          isDataFromHomeApi.current = true;
        }

        setSuggestionsData(data?.right?.suggested_users);
        localStorage.setItem(
          'contest_obj',
          JSON.stringify(data?.ads?.contest || [])
        );
      } else {
        sessionStorage.clear();
        localStorage.clear();
        navigate('/', { replace: true });
      }
    },
    onSettled: () => {
      setLoading(false);
      setAdsLoading(false);
      // Delay hiding shimmer to ensure visibility
      setTimeout(() => setIsFeedTypeChanging(false), 300);
    },
    refetchOnWindowFocus: false,
    onError: (err) => console.error('Feed fetch error:', err),
  });

  const _fetchFeedData = useCallback(async (pageNumber = 1) => {
    // Prevent _fetchFeedData for page 1 if data is from home API
    if (isDataFromHomeApi.current && pageNumber === 1) {
      return;
    }

    try {
      setLoading(true);
      const response = await axios.get(`${FeedPostApi + feedType}?page=${pageNumber}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
      });

      if (response.data.status) {
        if (pageNumber === 1) {
          setData(response.data.data);
          setPostData(formatFeedPosts(response.data.data?.data || []));
          setPage(1);
        } else {
          const newPosts = formatFeedPosts(response.data.data?.data || []);
          setPostData((prev) => [...prev, ...newPosts]);
          setData(response.data.data);
          setPage(pageNumber);
        }
        // Reset the flag only for pagination (pageNumber > 1)
        if (pageNumber > 1) {
          isDataFromHomeApi.current = false;
        }
      } else {
        // toast.error(response.data.error);
      }
    } catch (error) {
      // toast.error('Error fetching feed data: ' + error.message);
    } finally {
      setLoading(false);
    }
  }, [feedType, formatFeedPosts]);

  const handleNewPageData = useCallback(async () => {
    // Prevent pagination if data is not yet loaded or still fetching
    if (isLoading || isLoadingFeeds || !data?.last_page || page >= data?.last_page) {
      return;
    }

    setIsLoading(true);
    const nextPage = page + 1;

    try {
      await _fetchFeedData(nextPage); // Call _fetchFeedData for pagination
    } catch (error) {
      console.error('Error loading more data:', error);
    } finally {
      setIsLoading(false);
    }
  }, [page, isLoading, isLoadingFeeds, feedType, data?.last_page, _fetchFeedData]);

  // Handle feedType changes
  useEffect(() => {
    // Check if feedType has changed (not initial load)
    if (!isInitialLoad.current && previousFeedType.current !== feedType) {
      // Reset states for new feed type
      setPage(1);
      setPostData([]);
      setData({});
      setIsLoading(false);
      setIsFeedTypeChanging(true); // Show shimmer on feedType change
      isDataFromHomeApi.current = true; // Ensure _fetchFeedData is skipped for page 1
    }

    // Update refs
    isInitialLoad.current = false;
    previousFeedType.current = feedType;
  }, [feedType]);

  const handleLikeUsers = useCallback(
    async (otherId) => {
      setLikeSpinner(true);
      setLikeUsersModal(true);
      try {
        const response = await axios.get(
          `${adminBaseURL}user/post/likes/${otherId}`,
          authorize
        );
        if (response.data.status) {
          setLikeUsers(response.data.data);
        } else {
          toast.error(response.data.error);
          setLikeUsersModal(false);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLikeSpinner(false);
      }
    },
    [user_id]
  );

  const handleNewLikeUsers = useCallback(async () => {
    try {
      const response = await usersLikedPostApi({ post_id: postId, page });
      if (response.data.status) {
        const update = likeUsers.data.concat(response.data.data.data);
        setLikeUsers((prevUsers) => ({ ...prevUsers, data: update }));
        setLikePage((prevPage) => prevPage + 1);
      } else {
        toast.error(response.data.error);
      }
    } catch (error) {
      console.error(error);
    }
  }, [likePage, likeUsers, postId, user_id]);

  const indicatorStyles = useMemo(
    () => ({
      background: '#fff',
      width: 20,
      height: 4,
      display: 'inline-block',
      margin: '0 4px',
      borderRadius: '1px',
    }),
    []
  );

  const handleReserveWebinar = useCallback(
    async (post_id) => {
      try {
        const updatedData = postData.map((value) =>
          value.id === post_id
            ? { ...value, isReserve: !value.isReserve }
            : value
        );
        setPostData(updatedData);
        await axios.get(`${ReserveApi}${post_id}`, authorize);
      } catch (error) {
        console.error(error);
      }
    },
    [postData, user_id]
  );

  const handlePollAnswer = useCallback(
    async (post_id, answer) => {
      try {
        const response = await axios.post(
          `${adminBaseURL}user/post/poll/answer/submit`,
          {
            post_id,
            answer: answer + 1,
          },
          authorize
        );

        setPostData((prevData) =>
          prevData.map((post) =>
            post.id === post_id
              ? {
                ...post,
                right: answer + 1,
                percs: response.data.data,
                votes_count: post.votes_count + 1,
              }
              : post
          )
        );

        if (!response.data.status) {
          toast.error(response.data.action);
        }
        MixpanelManager.track(MixpanelEvents.pollAttempted, {
          post_id: post_id,
          user_id: user_id,
          answer_selected: answer + 1
        });
      } catch (error) {
        toast.error(error.message);
      }
    },
    [postData, user_id]
  );

  const handleLike = useCallback(
    async (post_id, reaction_type = "like") => {
      const prevDataState = postData;
      try {
        const targetPost = postData.find(
          (p) => p.original_id === post_id || p.id === post_id
        );
        const currentReaction = targetPost?.reaction || targetPost?.user_reaction;
        const wasLiked = Boolean(targetPost?.isLike || currentReaction);
        const isTogglingOff = Boolean(
          wasLiked &&
          currentReaction &&
          String(currentReaction).toLowerCase() === String(reaction_type).toLowerCase()
        );
        const nextIsLiked = !isTogglingOff;
        const nextReaction = isTogglingOff ? null : reaction_type;

        setPostData((prevData) =>
          prevData.map((post) => {
            if (post.original_id === post_id || post.id === post_id) {
              const wasPostLiked = Boolean(post.isLike || post.reaction || post.user_reaction);
              const postReaction = post.reaction || post.user_reaction;
              const isCurrentTogglingOff = Boolean(
                wasPostLiked &&
                postReaction &&
                String(postReaction).toLowerCase() === String(reaction_type).toLowerCase()
              );
              const nextPostIsLiked = !isCurrentTogglingOff;
              const nextPostReaction = isCurrentTogglingOff ? null : reaction_type;

              const currentCounts = post.reaction_counts && typeof post.reaction_counts === "object"
                ? { ...post.reaction_counts }
                : {};
              if (postReaction && currentCounts[postReaction]) {
                currentCounts[postReaction] = Math.max(
                  0,
                  Number(currentCounts[postReaction] || 0) - 1
                );
                if (currentCounts[postReaction] === 0) {
                  delete currentCounts[postReaction];
                }
              }
              if (nextPostReaction) {
                currentCounts[nextPostReaction] =
                  (Number(currentCounts[nextPostReaction]) || 0) + 1;
              }

              let updatedImages = post.like_users_images
                ? [...post.like_users_images]
                : [];
              if (nextPostIsLiked && !wasPostLiked && user?.data?.image) {
                updatedImages = [
                  user.data.image,
                  ...updatedImages.filter((img) => img !== user.data.image),
                ];
              } else if (!nextPostIsLiked && wasPostLiked && user?.data?.image) {
                updatedImages = updatedImages.filter(
                  (image) => image !== user?.data?.image
                );
              }

              const countDelta =
                nextPostIsLiked && !wasPostLiked
                  ? 1
                  : !nextPostIsLiked && wasPostLiked
                  ? -1
                  : 0;

              const totalLikesFromCounts = calculateTotalReactions(
                currentCounts,
                Math.max(0, (post.likes_count || 0) + countDelta)
              );

              const updatedPost = {
                ...post,
                isLike: nextPostIsLiked,
                reaction: nextPostReaction,
                reaction_counts: currentCounts,
                likes_count: totalLikesFromCounts,
                like_users_images: updatedImages,
              };

              if (
                postDetailContext?.postDetail &&
                (postDetailContext.postDetail.id === post_id ||
                  postDetailContext.postDetail.original_id === post_id)
              ) {
                postDetailContext.updatePostDetail({
                  ...postDetailContext.postDetail,
                  ...updatedPost,
                });
              }

              return updatedPost;
            }
            return post;
          })
        );

        await reactToPostApi({ post_id, reaction_type });
      } catch (error) {
        setPostData(prevDataState);
        toast.error(error.message);
      }
    },
    [postData, user_id, user?.data?.image, postDetailContext]
  );

  // ── Sync Feed PostData with PostDetailModal changes ──
  useEffect(() => {
    const modalPost = postDetailContext?.postDetail;
    if (!modalPost || (!modalPost.id && !modalPost.original_id)) return;
    const targetId = modalPost.original_id || modalPost.id;
    setPostData((prevData) => {
      let changed = false;
      const nextData = prevData.map((post) => {
        if (post.id === targetId || post.original_id === targetId) {
          if (
            post.isLike !== modalPost.isLike ||
            post.reaction !== modalPost.reaction ||
            post.likes_count !== modalPost.likes_count ||
            post.comments_count !== modalPost.comments_count ||
            post.isSave !== modalPost.isSave ||
            post.isShare !== modalPost.isShare
          ) {
            changed = true;
            return { ...post, ...modalPost };
          }
        }
        return post;
      });
      return changed ? nextData : prevData;
    });
  }, [postDetailContext?.postDetail]);

  const handleSave = useCallback(
    async (post_id) => {
      try {
        const updatedData = postData.map((value) =>
          value.original_id === post_id ? { ...value, isSave: !value.isSave } : value
        );
        setPostData(updatedData);
        const response = await savePostApi({ post_id });
        if (response.status) {
          // toast.success(response.action);
        }
      } catch (error) {
        toast.error(error.message);
      }
    },
    [postData, user_id]
  );

  const handleRepost = useCallback(
    async (post_id, caption) => {
      const targetPost = postData.find(
        (p) => p.id === post_id || p.original_id === post_id
      );
      if (!targetPost) return;

      const previousData = postData;
      const isQuoteRepost = Boolean(caption && typeof caption === "string" && caption.trim());
      const willBeShared = isQuoteRepost ? true : !targetPost.isShare;

      const baseSharesCount =
        Number(
          targetPost.shares_count ??
          targetPost.share_count ??
          targetPost.reposts_count ??
          0
        ) || (targetPost.repost_user?.name ? 1 : 0);

      const effectivePostId = targetPost.original_id || targetPost.id || post_id;
      const isPoll = targetPost.type === "poll" || Boolean(targetPost.option_1);
      const originalBaseCaption = targetPost.original_caption !== undefined
        ? targetPost.original_caption
        : (targetPost.repost_user ? "" : (targetPost.caption || ""));

      if (willBeShared) {
        const nextSharesCount = baseSharesCount + 1;

        // Construct the new repost post that will appear at top of feed
        const newRepostPost = {
          ...targetPost,
          id: `repost_${Date.now()}_${effectivePostId}`,
          original_id: effectivePostId,
          original_caption: originalBaseCaption,
          caption: isPoll ? "" : (isQuoteRepost ? caption.trim() : originalBaseCaption),
          repost_caption: isQuoteRepost ? caption.trim() : "",
          isShare: true,
          time: targetPost.time,
          repost_user: {
            id: user_id,
            name: splashData?.user?.name || user?.data?.name || "You",
            image: splashData?.user?.image || user?.data?.image,
            user_type: user?.data?.user_type || "doctor",
          },
          repost_user_id: user_id,
          shares_count: nextSharesCount,
        };

        // Insert new repost at the top of the feed and update existing cards
        setPostData((prev) => [
          newRepostPost,
          ...prev.map((p) =>
            p.id === post_id || p.original_id === post_id || p.id === effectivePostId || p.original_id === effectivePostId
              ? {
                ...p,
                isShare: true,
                shares_count: nextSharesCount,
              }
              : p
          ),
        ]);

        // Smooth scroll to the top of feed (after advertisement) where the new post is rendered
        setTimeout(() => {
          const anchor =
            document.getElementById("mr-first-post-anchor") ||
            document.getElementById("mr-post-form-anchor");
          if (anchor) {
            anchor.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 60);
      } else {
        const unsharedCount = Math.max(
          targetPost.repost_user?.name ? 1 : 0,
          baseSharesCount - 1
        );

        // Undo repost with smooth exit animation
        const userRepostPost = postData.find(
          (p) =>
            p.repost_user?.id === user_id &&
            (p.original_id === effectivePostId || p.id === effectivePostId || p.id === post_id)
        );

        if (userRepostPost) {
          // Trigger smooth collapse exit animation on the card
          setExitingPostIds((prev) => [...prev, userRepostPost.id]);

          // Update other cards' share state immediately
          setPostData((prev) =>
            prev.map((p) =>
              p.id === post_id || p.original_id === post_id || p.id === effectivePostId || p.original_id === effectivePostId
                ? {
                  ...p,
                  isShare: false,
                  shares_count: unsharedCount,
                }
                : p
            )
          );

          // After exit animation completes (550ms), remove smoothly from DOM
          setTimeout(() => {
            setPostData((prev) =>
              prev.filter((p) => p.id !== userRepostPost.id)
            );
            setExitingPostIds((prev) =>
              prev.filter((id) => id !== userRepostPost.id)
            );
          }, 550);
        } else {
          // Update the post card directly
          setPostData((prev) =>
            prev.map((p) =>
              p.id === post_id || p.original_id === post_id || p.id === effectivePostId || p.original_id === effectivePostId
                ? {
                  ...p,
                  isShare: false,
                  shares_count: unsharedCount,
                }
                : p
            )
          );
        }
      }

      try {
        let response;
        if (isQuoteRepost) {
          try {
            response = await axios.post(
              `${RepostApi}${effectivePostId}`,
              { caption: caption.trim() },
              authorize
            );
          } catch (postErr) {
            response = await axios.get(
              `${RepostApi}${effectivePostId}?caption=${encodeURIComponent(caption.trim())}`,
              authorize
            );
          }
        } else {
          response = await axios.get(`${RepostApi}${effectivePostId}`, authorize);
        }

        if (response.data?.status) {
          const toastMsg = willBeShared
            ? lang?.repost_success || "Reposted to your feed"
            : lang?.repost_removed || "Repost removed from your feed";
          showToast(toastMsg, "success");

          if (response.data?.data?.id && willBeShared) {
            const serverId = response.data.data.id;
            setPostData((prev) =>
              prev.map((p) =>
                typeof p.id === "string" && p.id.startsWith("repost_")
                  ? {
                    ...p,
                    id: serverId,
                    repost_caption: isQuoteRepost ? caption.trim() : "",
                  }
                  : p
              )
            );
          }
        } else {
          setPostData(previousData);
          showToast(response.data?.action || response.data?.message || "Failed to repost", "error");
        }
      } catch (error) {
        setPostData(previousData);
        showToast(error.response?.data?.message || error.message || "Failed to repost", "error");
      }
    },
    [postData, user_id, splashData, authorize, showToast, lang]
  );

  const handleFollow = useCallback(
    async (id) => {
      const updatedData = postData.map((value) =>
        value.user?.id === id
          ? {
            ...value,
            user: {
              ...value.user,
              follow: !value.user?.follow,
            },
          }
          : value
      );

      setPostData(updatedData);
      try {
        const res = await axios.get(`${FollowApi}${id}`, authorize);
        if (!res.data.status) {
          console.log(res.data.error);
        }
        const isFollowing = updatedData.find(p => p.user?.id === id)?.user?.follow;
        MixpanelManager.track(isFollowing ? MixpanelEvents.followUser : MixpanelEvents.unFollowUser, {
          followed_user_id: id,
          user_id: user_id
        });
      } catch (error) {
        console.error('Error following user:', error);
      } finally {
        setIsLoading(false);
      }
    },
    [postData, user_id]
  );

  const handleGetComments = useCallback(
    async (post_id) => {
      setIsLoading(true);
      const id = post_id || postId;
      try {
        const response = await axios.get(`${GetCommentsApi}${id}?page=1`, authorize);
        if (response.data.status) {
          setPostComments(response?.data?.data);
        }
        setIsLoading(false);
      } catch (error) {
        console.error(error);
      }
    },
    [postId, user_id]
  );

  const handlePostReport = useCallback(
    async (reportInput) => {
      if (!reportInput) {
        toast.error('Please enter a report');
        return;
      }
      setIsLoading(true);
      try {
        const reportData = {
          feature_id: dropDownId,
          user_id,
          report: reportInput,
          type: 'post',
        };
        const response = await axios.post(
          `${adminBaseURL}app/report`,
          reportData,
          authorize
        );
        if (response.data.status) {
          toast.success('Reported Successfully!');
          setReportModal(false);
        } else {
          toast.error(response.data.action);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setIsLoading(false);
      }
    },
    [dropDownId, user_id]
  );

  useEffect(() => {
    const clearSessionStorageOnReload = () => {
      ['prevFeedData', 'prevFeedDataDetails'].forEach((key) =>
        sessionStorage.removeItem(key)
      );
    };
    window.addEventListener('beforeunload', clearSessionStorageOnReload);
    return () => {
      window.removeEventListener('beforeunload', clearSessionStorageOnReload);
    };
  }, []);

  const toggleModal = useCallback((id) => {
    setPollId(id);
    setModalOpen((prev) => !prev);
  }, []);

  const isFeedsEmpty = useMemo(
    () =>
      leftSideFeeds.live?.length === 0 && leftSideFeeds.upcoming?.length === 0,
    [leftSideFeeds]
  );

  const viewAllPurchased = (course_type, pageType, type) => {
    if (pageType === location.pathname) {
      if (type === 'courses') {
        navigate(COURSES + '/1', { state: { selectedCourseType: course_type } });
      } else if (type === 'events') {
        navigate(EVENTS + '/3');
      }
    }
    window.scrollTo(0, 0);
  };

  const handleVideoPlay = (index) => {
    setPlayingVideo(index);
  };

  const removePollAnswer = async (id) => {
    try {
      const response = await axios.get(
        `${adminBaseURL}user/post/poll/answer/remove/${id}`,
        authorize
      );
      if (response.data.status) {
        setPostData((prevData) =>
          prevData.map((post) =>
            post.id === id
              ? {
                ...post,
                right: 0,
                votes_count: post.votes_count - 1,
              }
              : post
          )
        );
        return response.data;
      } else {
        console.error('Error removing poll answer:', response.data.action);
        return null;
      }
    } catch (error) {
      console.error('Error while removing poll answer:', error.message);
      return null;
    }
  };

  const editWebinarTab = (edit) => {
    setEditWebinar(edit);
  };

  const handlePostSelect = (object) => {
    setSelectedPost(object);
  };

  const updatePost = (postId, newCaption) => {
    setPostData((prevData) =>
      prevData.map((post) =>
        post.id === postId ? { ...post, caption: newCaption } : post
      )
    );
  };

  const deletePost = (postId) => {
    setPostData((prevData) =>
      prevData.filter((post) => post.original_id !== postId)
    );
  };

  // Use react-query refetch for refreshing feed data
  const refetchFeedData = useCallback(() => {
    setIsFeedTypeChanging(true); // Show shimmer on refetch
    refetch();
  }, [refetch]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.setItem('isReload', 'true');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    const isReload = localStorage.getItem('isReload');
    if (isReload === 'true') {
      setPostData([]);
      localStorage.removeItem('isReload');
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <>
      <Container fluid className="feed-page-theme">
        <Row>
          <Col xs={12} className="px-0">
            <NavBar showPost={showPost} setShowPost={setShowPost} />
          </Col>
        </Row>
        <Row
          className="d-flex justify-content-center custom-pt"
        >
          <Col
            xs={12} sm={12} md={12} lg={3} xl={3}
            className="d-none d-xl-flex flex-column flex-wrap align-content-end"
          >
            <div style={{ position: 'sticky', top: '5rem', width: '275px', zIndex: 1 }}>
              <PostSideFilters />
              {!isFeedsEmpty && <div style={{ marginTop: '15px' }}></div>}
              <FeedAdvertisement
                left={true}
                type="feed"
                ads={leftSideAds}
                loading={adsLoading}
                new_contest_obj={contest_obj}
              />
            </div>
          </Col>

          {/* Main Content - Keep as div to preserve InfiniteScroll behavior */}
          <div
            className="find_scroll col-md-12 feed-center-column-main"
            style={{
              maxWidth: '690px',
              width: '100%',
              paddingBottom: '4.5rem',
            }}
          >
            <FeedMobileFilter />

            <div id="mr-post-form-anchor">
              <PostForm
                selectedPost={selectedPost}
                editWebinar={editWebinar}
                setEditWebinar={setEditWebinar}
                handlePostSelect={handlePostSelect}
                showPost={showPost}
                setShowPost={setShowPost}
                refetch={refetchFeedData}
              />
            </div>
            <FeedSponsorPost
              loading={isLoadingFeeds || isLoading || isFeedTypeChanging}
              new_contest_obj={contest_obj}
            />
            <div id="mr-first-post-anchor" style={{ scrollMarginTop: '90px' }} />
            <InfiniteScroll
              key={feedType} // Force re-render when feedType changes
              pageStart={0}
              loadMore={handleNewPageData}
              hasMore={!isLoadingFeeds && !isFeedTypeChanging && page < data?.last_page}
              loader={<PostCardShimmer count={1} />}
              useWindow={true}
              threshold={100}
            >
              <>
                {(loading || isLoadingFeeds || isFeedTypeChanging) && !isLoading ? (
                  <div className="mt-3">
                    <PostCardShimmer count={2} />
                  </div>
                ) : (
                  postData &&
                  postData.map((value, index) =>
                    index === 3 ? (
                      <ProfileSuggestionSlider
                        key="suggestions"
                        suggestions={suggestionsData}
                        updateSuggestions={setSuggestionsData}
                      />
                    ) : (
                      <div
                        key={value.id}
                        className={
                          exitingPostIds.includes(value.id)
                            ? "mr-post-card-exiting"
                            : ""
                        }
                      >
                        <PostCard
                          value={value}
                          postDropDown={postDropDown}
                          setPostDropDown={setPostDropDown}
                          setReportModal={setReportModal}
                          setDropDownId={setDropDownId}
                          dropDownId={dropDownId}
                          handleRepost={handleRepost}
                          handleSave={handleSave}
                          handleFollow={handleFollow}
                          setShowPost={setShowPost}
                          editWebinarTab={editWebinarTab}
                          handlePostSelect={handlePostSelect}
                          updatePost={updatePost}
                          deletePost={deletePost}
                          updatePostDetail={updatePostDetail}
                          handleLikeUsers={handleLikeUsers}
                          handleLike={handleLike}
                          handleGetComments={handleGetComments}
                          setPostModal={setPostModal}
                          setPostId={setPostId}
                          handleReserveWebinar={handleReserveWebinar}
                          handlePollAnswer={handlePollAnswer}
                          toggleModal={toggleModal}
                          removePollAnswer={removePollAnswer}
                          refetch={refetchFeedData}
                          playingVideo={playingVideo}
                          handleVideoPlay={handleVideoPlay}
                          indicatorStyles={indicatorStyles}
                        />
                      </div>
                    )
                  )
                )}
              </>
            </InfiniteScroll>
          </div>

          {/* Right Sidebar - Hidden on small screens AND iPad Pro */}
          <Col xs={12} sm={12} md={12} lg={3} xl={3} className="d-none d-xl-block">
            <LiveFeeds
              leftSideFeeds={leftSideFeeds}
              isLoading={isLoadingFeeds || isFeedTypeChanging || loading || isRefetching}
              isRefetching={isRefetching}
            />
            <SuggestedProfiles
              suggestions={suggestionsData}
              updateSuggestions={setSuggestionsData}
            />
            <SuggestedCoursesEvents
              tabType="courses-and-events"
              popularCourses={popularCourses}
              suggestedEvents={suggestedEvents}
              isLoading={isLoadingFeeds || isFeedTypeChanging || loading}
              viewAllPurchased={() => viewAllPurchased('popular-courses', '/feed', 'courses')}
            />
            <div style={{ position: 'sticky', top: '5rem', zIndex: 1 }}>
              <FeedAdvertisement
                right={true}
                ads={rightSideAds}
                loading={adsLoading}
                new_contest_obj={contest_obj}
              />
              <div style={{ marginTop: rightSideAds.length === 0 ? '0px' : '14px' }}>
                <FooterLinks />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <LikeUsersModal
        isOpen={likeUsersModal}
        toggleLikesModal={() => setLikeUsersModal(!likeUsersModal)}
        likeSpinner={likeSpinner}
        likeUsers={likeUsers}
        handleNewLikeUsers={handleNewLikeUsers}
      />
      {reportModal && (
        <ReportModal
          isOpen={reportModal}
          toggle={setReportModal}
          handleReport={handlePostReport}
          isLoading={isLoading}
          heading={lang.report_post}
        />
      )}
      {modalOpen && (
        <PollLikesModal
          modal={modalOpen}
          toggleModal={toggleModal}
          pollId={pollId}
        />
      )}
    </>
  );
});

export default Feed;
